import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";

export class PqmFieldDate extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "date:date", "datetime:datetime" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent('<input type="' + {
			'date': 'date',
			'datetime': 'datetime-local',
		}[this.control] + `" mu='value#value|dateToInput(`
			+ (this.control === 'date' ? 'true' : 'false')
			+ `)' class="form-control" />`);
	}
}

PqmFieldRegister.register(PqmFieldDate);